import { render, staticRenderFns } from "./KioskBasketButton.vue?vue&type=template&id=54b773a1&scoped=true"
import script from "./KioskBasketButton.vue?vue&type=script&lang=js"
export * from "./KioskBasketButton.vue?vue&type=script&lang=js"
import style0 from "./KioskBasketButton.vue?vue&type=style&index=0&id=54b773a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b773a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b773a1')) {
      api.createRecord('54b773a1', component.options)
    } else {
      api.reload('54b773a1', component.options)
    }
    module.hot.accept("./KioskBasketButton.vue?vue&type=template&id=54b773a1&scoped=true", function () {
      api.rerender('54b773a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KioskBasketButton.vue"
export default component.exports